import React from 'react';
import { useTranslation } from 'react-i18next';
import { queryParam } from 'utils/query';

export const RankingStartupContext = React.createContext();

// Initial values for the state
export const RankingStartupInitialState = {
    ranking: {
        id: '2026',
        name: '2026',
        year: '2026',
        country: 'BR'
    },
    application: { applied: false, steps: {} },
    investor: {},
    investments: [],
    validate: false,
    relationships: [],
    startups: [],
    startupDetails: {},
    contracts: [],
    searchedCompany: {},
    contractPoints: 0,
    startupId: 0,
    startupTerm: {},
    term: {},
    redirectTo: '',
    companyDetails: {}
};

export const RankingStartupContextProvider = ({ children }) => {
    const { t } = useTranslation('ranking');

    const initial = RankingStartupInitialState;
    initial.startupId = queryParam('startupId') || 0;

    // Define variables holder to be used on the module
    const [vars, setVars] = React.useState(initial);
    const addVars = newVars => setVars(old => ({ ...old, ...newVars }));

    const stateValue = {
        t,
        vars,
        addVars,
        setVars
    };
    return (
        <RankingStartupContext.Provider value={stateValue}>
            {children}
        </RankingStartupContext.Provider>
    );
};
